import React, { useEffect } from "react";

// Import your components
import Getapps from "../Getapps.jsx";
import Service from "../Service.jsx";
import Maamaasmoment from "../Maamaasmoment.jsx";
import Toptobottom from "../Toptobottom.jsx";
import Appinformation from "../Appinformation.jsx";
import MainBanner from "../MainBanner.jsx";
import Ourclints from "../Ourclints.jsx";
import Faqs from "../Faqs.jsx";
import Homegeleery from "../Homegeleery.jsx";
import Footer from "../Footer.jsx"

const AuthPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: "white", overflowY: "auto", height: "100vh" }}>
      <MainBanner />
      <Homegeleery />
      <Ourclints />
      {/* Optional: Uncomment if needed later */}
      {/* <Stack /> */}
      <Service />
      {/* <NewwhychosesUS /> */}
      <Getapps />
      <Maamaasmoment />
      <Faqs />
      <Appinformation />
      {/* Optional: Uncomment if needed later */}
      {/* <Homesliderdata /> */}
      {/* <AllvariousCards /> */}
      {/* <Homesecondslidercards /> */}
      {/* <HoveredCards /> */}
      <Toptobottom />
      <Footer />
    </div>
  );
};

export default AuthPage;
